export default class PageStateManager {

  constructor(paymentPage) {
    this.noVoucherBox = document.getElementById('no-voucher')
    this.voucherErrorBox = document.getElementById('voucher-error')
    this.formElement = document.getElementById('payment-form')
  }

  showPaymentForm() {
    this.voucherErrorBox.className = 'is-hidden'
    this.noVoucherBox.className = 'is-hidden'
    this.formElement.className = 'notification payment-formElement'
  }

  showNoVoucherBox() {
    this.noVoucherBox.className = 'notification no-voucher'
    this.voucherErrorBox.className = 'is-hidden'
    this.formElement.className = 'is-hidden'
  }

  showVoucherErrorBox() {
    this.voucherErrorBox.className = 'notification voucher-error'
    this.noVoucherBox.className = 'is-hidden'
    this.formElement.className = 'is-hidden'
  }
}
